import React from "react";
import "./Footer.css";
import {useLanguage} from "../context/LanguageContext";
import etisalatLogoAr from "../assets/img/etisalat_logo_new_ar.png";

const Footer = () => {
  const {language, setLanguage} = useLanguage();
  const etisalatLogo = require("../assets/img/etisalat_logo_new.png");
  const etisalatLogoAr = require("../assets/img/etisalat_logo_new_ar.png");

  return (
          language === "en" ?(
              <div>
                <footer>



                  <div className="footer-container">
                    <div className="foot-top">
                      <ul>
                        <li>
                          <a
                              href="https://www.etisalat.ae/en/footer/about-us.html"
                              target="_blank"
                              rel="noopener noreferrer"
                          >About us</a>
                        </li>
                        <li>
                          <a
                              href="https://www.etisalat.ae/content/dam/dx_eitsalat_ae/en/system/wst/assets/docs/consumer/general/code-of-conduct.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                          >Code of Conduct</a>
                        </li>
                        <li>
                          <a
                              href="https://www.etisalat.ae/en/footer/privacy-policy.html"
                              target="_blank"
                              rel="noopener noreferrer"
                          >Privacy Policy</a>
                        </li>
                        <li>
                          <a
                              href="https://www.etisalat.ae/en/footer/terms-and-conditions.html"
                              target="_blank"
                              rel="noopener noreferrer"
                          >Terms & Conditions</a>
                        </li>
                        <li>
                          <a
                              href="https://www.etisalat.ae/en/footer/doing-business-with-us.html"
                              target="_blank"
                              rel="noopener noreferrer"
                          >Etisalat Tenders</a>
                        </li>
                        <li>
                          <a
                              href="https://careers.etisalat.ae/en/index.html"
                              target="_blank"
                              rel="noopener noreferrer"
                          >Careers</a>
                        </li>
                      </ul>
                    </div>
                    <div className="foot-of-footer">
                      <p className="copy-mob">© 2022 Etisalat. All Rights Reserved.</p>
                      <div className="logowrp">
                        <img src={etisalatLogo} alt="Etisalat Logo"
                             className="img-fluid"/>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>

          ): (<div>
            <footer>


              <div className="footer-container_ar">
                <div className="foot-top">
                  <ul>
                    <li>
                      <a
                          href="https://www.etisalat.ae/en/footer/about-us.html"
                          target="_blank"
                          rel="noopener noreferrer"
                      >نبذة عامة</a>
                    </li>
                    <li>
                      <a
                          href="https://www.etisalat.ae/content/dam/dx_eitsalat_ae/en/system/wst/assets/docs/consumer/general/code-of-conduct.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                      >القواعد السلوكية</a>
                    </li>
                    <li>
                      <a
                          href="https://www.etisalat.ae/en/footer/privacy-policy.html"
                          target="_blank"
                          rel="noopener noreferrer"
                      >سياسة الخصوصية</a>
                    </li>
                    <li>
                      <a
                          href="https://www.etisalat.ae/en/footer/terms-and-conditions.html"
                          target="_blank"
                          rel="noopener noreferrer"
                      >الشروط والأحكام</a>
                    </li>
                    <li>
                      <a
                          href="https://www.etisalat.ae/en/footer/doing-business-with-us.html"
                          target="_blank"
                          rel="noopener noreferrer"
                      >مناقصات اتصالات</a>
                    </li>
                    <li>
                      <a
                          href="https://careers.etisalat.ae/en/index.html"
                          target="_blank"
                          rel="noopener noreferrer"
                      >وظائف</a>
                    </li>
                  </ul>
                </div>
                <div className="foot-of-footer">
                  <p className="copy-mob">© 2022 اتصالات. جميع الحقوق محفوظة</p>
                  <div className="logowrp">
                    <img src={etisalatLogoAr} alt="Etisalat Logo"
                         className="img-fluid"/>
                  </div>
                </div>
              </div>
            </footer>
          </div>)

  );
};

export default Footer;
